import {
  AfterViewInit,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { FormControl, ValidatorFn, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AppConstants } from '@wz-constants';
import {
  AgencyModels,
  HealthModels,
  PolicyModels,
  QuotationModels,
} from '@wz-models';
import { AutoUnsubscribeComponent } from '@wz-utilities/auto-unsubscribe.component';
import * as CryptoJS from 'crypto-js';
import { HealthInsuranceService } from 'libs/modules/tunnelsante/services/health-insurance.service';
import { HealthQuotationService } from 'libs/modules/tunnelsante/services/health-quotation.service';
import { InteractionService } from 'libs/modules/tunnelsante/services/interaction.service';
import moment from 'moment';
import { Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { Question } from '../../health-quotation-formB2C/factory-age-validators';
import { TaggingService } from '../../services/tagging.service';

import AgencyDetails = AgencyModels.AgencyDetails;

@Component({
  selector: 'wz-demander-devis-dialog',
  templateUrl: './demander-devis-dialog.component.html',
  styleUrls: ['./demander-devis-dialog.component.scss'],
  standalone: false,
})
export class DemanderDevisDialogComponent
  extends AutoUnsubscribeComponent
  implements OnInit, AfterViewInit
{
  get agencyDetails(): AgencyModels.AgencyDetails {
    return this._agencyDetails;
  }

  @Input() set agencyDetails(value: AgencyModels.AgencyDetails) {
    this._agencyDetails = value;
  }
  private _agencyDetails!: AgencyDetails | any;
  olderThan80(date: string): boolean {
    if (date) {
      return moment().diff(moment(date, 'dd/MM/yyyy'), 'years') >= 80;
    }
    return false;
  }
  metas!: HealthModels.HealthPolicyPricingMetadatas;

  @Input() readonly = false;
  @Input()
  package!: PolicyModels.PackageEnum;
  @Input()
  staggering = QuotationModels.QuittancementEnum.Annuel;
  @Input()
  listeReponseAfi!: QuotationModels.ReponseAfiExport[];
  @Input()
  formulas!: PolicyModels.FormulaMetadataDictionary;
  @Input()
  selectedFormula!: QuotationModels.FormulaChoice;

  @Output()
  changes = new EventEmitter<QuotationModels.FormulaChoice>();

  isUpdating = false;
  isFirstLoading = true;
  error = null;
  isAutoType = true;
  number_phone = '';
  quotationParamOrigin = null;

  public quotationForm!: HealthModels.QuotationForm;
  private defaultcontrolListeParam!: Question[];
  clientPrice!: QuotationModels.Staggered<number>;
  brokerCommissions!: QuotationModels.Staggered<number>;
  quotation!: HealthModels.QuotationSummary;

  public optionalWarrantiesDescriptions = {};
  public optionalWarrantiesPercentages = {};
  public universalNeedsWithImage = {};

  public currentFormulaWithGroup!: PolicyModels.FormulaWithFormGroup;
  public formulasWithGroup: PolicyModels.FormulaWithFormGroup[] = [];

  private formula$ = new Subject<PolicyModels.FormulaMetadata>();

  //Control validator:
  emailCtrl!: FormControl;
  email: string = '';

  constructor(
    public dialogRef: MatDialogRef<DemanderDevisDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
    private healthInsuranceService: HealthInsuranceService,
    private healthQuotationService: HealthQuotationService,
    private interactionService: InteractionService,
    private taggingService: TaggingService,
  ) {
    super();
  }

  ngAfterViewInit(): void {
    this.setNumberSite();
    this.applyStylesAndImages();
  }

  ngOnInit(): void {
    this.setNumberSite();

    setTimeout(() => {
      this.healthInsuranceService.updateStepper(1);
    }, 0);

    //Mail Control
    this.emailCtrl = new FormControl(null, [
      Validators.required,
      this.EmailNotBrokerValidator.bind(this),
      Validators.email,
    ]);
    this.email = this.data.email;
  }

  setNumberSite() {
    let paramOrigin = localStorage.getItem('paramOrigin');
    this.quotationParamOrigin = null;
    if (!paramOrigin) {
      this.number_phone = AppConstants.SiteNumber.NUMBER;
    } else {
      this.number_phone = AppConstants.SiteNumber.NUMBER_FRNACHISE;
    }
  }

  EmailNotBrokerValidator: ValidatorFn | any = (control: FormControl) => {
    return this._agencyDetails &&
      control.value &&
      (control.value.toLowerCase() ==
        this._agencyDetails.headOfAgency.email.toLowerCase() ||
        control.value.toLowerCase() ==
          this._agencyDetails.mainBroker.brokerEmail.toLowerCase())
      ? { mailBroker: true }
      : null;
  };

  valider: boolean = false;

  validateDemandeDevis() {
    if (this.isUpdating) {
      return;
    }
    //Set email in Control list param:
    let dataUpdated = this.healthInsuranceService.getStoredData();

    this.quotationForm = this.data.dataStoredQuotation.quotationForm;

    this.quotationForm = {
      ...this.quotationForm,
      ...dataUpdated.quotationForm,
    };

    //Tarif selectionné
    this.quotationForm.vadInfo.tarif_Selected = this.data.tarif;
    //recuperation rang
    this.quotationForm.vadInfo.rang = this.data.numeroRang; // Mise en commentaire
    // this.defaultcontrolListeParam = this.data.dataStoredQuotation.controlListeParam;
    this.defaultcontrolListeParam = dataUpdated.controlListeParam;

    if (this.defaultcontrolListeParam[12].QuestionValue != '0') {
      //contact
      var contact = this.defaultcontrolListeParam[12].QuestionValue.split(';');
      //contact[0];//telephone
      contact[1] = this.data.email; //email

      //Set value on controllistParam
      this.setQuestionValue('Contact', contact[0] + ';' + contact[1]);
      this.quotationForm.vadInfo.tarifier = 'non_envoye_email';
    }

    //this.quotationForm.vadInfo.tarifier = "oui_init_pricingMetadatas";
    let dataStored: HealthModels.HealthQuotationStoredData = {
      quotationForm: this.quotationForm,
      brokerFees: this.data.dataStoredQuotation.brokerFees,
      controlListeParam: this.defaultcontrolListeParam,
      formulaChoice: this.data.dataStoredQuotation.formulaChoice,
      currentStaggering: this.data.dataStoredQuotation.currentStaggering,
      package: this.healthInsuranceService.packageId,
      tarifPrix: this.data.tarif.montant,
      codeFormule: this.data.tarif.codeFormule,
      TypeProduit: this.data.tarif.produitTarif,
      quotationParamOrigin: dataUpdated.quotationParamOrigin,
      quotationAcceptCompMT: dataUpdated.quotationAcceptCompMT,
      quotationCodeOrigin: dataUpdated.quotationCodeOrigin,
      quotationCodeParrain: dataUpdated.quotationCodeParrain,
      quotationBaseOrigin: dataUpdated.quotationBaseOrigin,
      quotationNavigator: this.healthInsuranceService.getInfoNavigator(),
    };
    this.currentFormulaWithGroup = this.data.currentFormulaWithGroup;
    this.selectFormula(this.currentFormulaWithGroup);

    //Tarif selectionné
    this.quotationForm.vadInfo.tarif_Selected = this.data.tarif;
    const storedData = {
      ...dataStored,
      quotationForm: {
        ...dataStored.quotationForm,
      },
      formulaChoice: {
        ...dataStored.formulaChoice,
      },
      brokerFees: {
        ...dataStored.brokerFees,
      },
      package: dataStored.package,
      // tarifPrix: dataStored.tarifPrix + " €  | " + parseFloat(dataStored.tarifPrix) * 12 + " €",
      tarifPrix: dataStored.tarifPrix,
      codeFormule: dataStored.codeFormule,
      TypeProduit: dataStored.TypeProduit,
    } as HealthModels.HealthQuotationStoredData;

    this.isUpdating = true;
    // debugger; // utile
    this.healthQuotationService
      .createQuotation(storedData)
      .pipe(finalize(() => (this.isUpdating = false)))
      .subscribe(
        (publicId: any) => {
          this.healthInsuranceService.setQuotationId(publicId['result']);
          this.quotationForm.vadInfo.leadId =
            publicId['quotationData']['quotationRequest']['leadId'];
          this.healthInsuranceService.setData(storedData);
          //Va afficher la prochaine fenetre
          this.valider = true;

          setTimeout(() => {
            //AFI Sante
            this.applyUpdateImageAndButton(
              'afisante_affiliation',
              {
                imgMail: 'assets/img/mailSend_afisante.svg',
                imgClose: 'assets/img/close_afisante.svg',
              },
              'referenceDossierAfiSante',
              'retourOffreAfisante',
            );

            //mutuelle online
            this.applyUpdateImageAndButton(
              'mutuelleonline_affiliation',
              {
                imgMail: 'assets/img/mailSend_mutuelle_online.svg',
                imgClose: 'assets/img/close_mutuelle_online.svg',
              },
              'referenceDossierMutuelleOnline',
              'retourOffreMutuelleOnline',
            );

            //La bonne mutuelle
            this.applyUpdateImageAndButton(
              'labonnemutuelle_affiliation',
              {
                imgMail: 'assets/img/mailSend_labonnemutuelle.svg',
                imgClose: 'assets/img/close_la_bonne_mutuelle.svg',
              },
              'referenceDossierLaBonneMutuelle',
              'retourOffreLaBonneMutuelle',
            );

            //Assurance et mutuelle
            this.applyUpdateImageAndButton(
              'assuranceetmutuelle_affiliation',
              {
                imgMail: 'assets/img/mailSend_assuranceetmutuelle.svg',
                imgClose: 'assets/img/close_assurance_et_mutelle.svg',
              },
              'referenceDossierAssuranceEtMutuelle',
              'retourOffreAssuranceEtMutuelle',
            );
          }, 0);

          if (window['tC']) {
            let compagnie = '';
            let VisiteurId = this.taggingService.checkVisiteurId();

            if (
              this.data.tarif.produitTarif == 'CEGEMAEss' ||
              this.data.tarif.produitTarif == 'CEGEMAV' ||
              this.data.tarif.produitTarif == 'CEGE_EQUILIBRE' ||
              this.data.tarif.produitTarif ==
                'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
              this.data.tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE' ||
              this.data.tarif.produitTarif == 'KEREIS_SERENITE'
            ) {
              compagnie = 'CEGEMA';
            }

            if (this.data.tarif.produitTarif == 'VITAMIN3') {
              compagnie = 'APIVIA';
            }
            if (
              this.data.tarif.produitTarif == 'ZEN_SANTE_55_PLUS' ||
              this.data.tarif.produitTarif == 'ZEN_SANTE_FAMILLE' ||
              this.data.tarif.produitTarif == 'ZEN_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO'
            ) {
              compagnie = 'ZENIOO';
            }
            if (
              this.data.tarif.produitTarif == 'SANTE_MALIN' ||
              this.data.tarif.produitTarif == 'SPVIE_GENIUS_ESSENTIELLE' ||
              this.data.tarif.produitTarif == 'SPVIE_SANTE_NOVA_NR' ||
              this.data.tarif.produitTarif == 'SPVIE_GENIUS_CONFORT'
            ) {
              compagnie = 'SPVIE';
            }
            if (
              this.data.tarif.produitTarif == 'PARTICULIER' ||
              this.data.tarif.produitTarif == 'SWLF_RETRAITES'
            ) {
              compagnie = 'SWISS LIFE';
            } else if (
              this.data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
              this.data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE' ||
              this.data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
              this.data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
              this.data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO' ||
              this.data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'RELAXEO2' ||
              this.data.tarif.produitTarif == 'ESS_SANTE_FAMILLE' ||
              this.data.tarif.produitTarif == 'ESS_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'PROGR_SANTE_FAMILLE' ||
              this.data.tarif.produitTarif == 'PROGR_SANTE_SENIOR' ||
              this.data.tarif.produitTarif == 'AC_PRIVILEGE' ||
              this.data.tarif.produitTarif ==
                'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
              this.data.tarif.produitTarif ==
                'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR' ||
              this.data.tarif.produitTarif ==
                'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR' ||
              this.data.tarif.produitTarif ==
                'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
            ) {
              compagnie = 'MEILLEURSTAUX SANTE';
            }

            let sha256Mail = '';
            let md5Mail = '';

            sha256Mail = CryptoJS.SHA256(this.data.email).toString(
              CryptoJS.enc.Hex,
            );
            md5Mail = CryptoJS.MD5(this.data.email).toString(CryptoJS.enc.Hex);

            window['tc_vars'] = {
              env_site: 'meilleurtaux santé',
              env_work: 'production',
              env_visiteur_id: VisiteurId,
              page_nom: 'resultats des tarifs',
              page_metier: 'sante',
              page_template: 'resultat tunnel',
              page_tunnel: 'comparer les offres',
              tunnel_demande: '',
              tunnel_etape: '',
              tunnel_num_etape: '',
              tunnel_nom_etape: '',
              tunnel_nom_sous_etape: '',
              user_email: this.data.email,
              user_email_sha256: sha256Mail,
              user_email_md5: md5Mail,
              lead_id: this.quotationForm.vadInfo.leadId,
              lead_typologie: 'lead chaud',
            };

            window['tC'].event.lead(this, {
              event_id: 'lead',
              event_categorie: 'lead devis',
              event_nom: 'demande de devis',
              event_metier: 'sante',
              event_demande: 'devis',
              event_statut: 'succes',
              event_user_email_sha256: sha256Mail,
              event_lead_id: this.quotationForm.vadInfo.leadId,
              event_lead_typologie: 'lead chaud',
              // 'event_lead_beneficiaire':'1',
              event_produit: this.data.tarif.produitTarif,
              event_formule: this.replaceFormule(this.data.tarif.codeFormule),
              event_partenaire: compagnie,
              event_produit_montant_mensuel: this.ate(
                this.data.tarif.montant,
              ).toFixed(2),
              event_produit_montant_annuel: (
                this.ate(this.data.tarif.montant) * 12
              ).toFixed(2),
            });
          }
        },
        (err) => {
          this.interactionService.showError(err);
        },
      );
  }
  public selectFormula(formulaWithGroup: PolicyModels.FormulaWithFormGroup) {
    if (this.readonly) {
      return;
    }

    setTimeout(() => {
      this.currentFormulaWithGroup = formulaWithGroup;
      this.formula$.next(formulaWithGroup.formula);
    }, 0);
  }

  closeModals(): void {
    this.dialogRef.close();
    this.valider = false;
  }
  onNoClick(): void {
    this.dialogRef.close();
  }
  ate(a: string) {
    a = a.replace(',', '.');
    var r: number = +a;
    return r;
  }

  //Get input value
  getInputValue(inputValue: string) {
    this.data.email = inputValue;
  }

  setQuestionValue(keyString: any, valeur: any) {
    var find_object: any = this.defaultcontrolListeParam.find(
      (x) => x.KeyQ == keyString,
    );

    if (keyString == 'EnfantsDateNaissance') {
      find_object.QuestionValue += valeur + ';';
    } else {
      find_object.QuestionValue = valeur;
    }
  }

  invalidEmail(email: string): boolean {
    const value = email.toLowerCase();
    if (value.includes('@test')) {
      return true;
    } else {
      return false;
    }
  }
  replaceFormule(f: string) {
    let a = Array.from(f.trim());
    return 'Formule ' + a[a.length - 1];
  }

  applyStylesAndImages() {
    //AFI Sante
    this.updateDOM(
      'afisante_affiliation',
      'bodyAffiliationSubContainer',
      'bodyAffiliationButContainer',
    );
    //Mutuelle online
    this.updateDOM(
      'mutuelleonline_affiliation',
      'bodyMutuelleOnlineSubContainer',
      'bodyMutuelleOnlineButContainer',
    );
    //La bonne mutuelle
    this.updateDOM(
      'labonnemutuelle_affiliation',
      'bodyLaBonneMutuelleSubContainer',
      'bodyLaBonneMutuelleButContainer',
    );
    //Assurance et mutuelle
    this.updateDOM(
      'assuranceetmutuelle_affiliation',
      'bodyAssuranceEtMutuelleSubContainer',
      'bodyAssuranceEtMutuelleButContainer',
    );
  }

  private updateDOM(
    expectedCode: string,
    containerClass: string,
    containerButton: string,
  ) {
    const parameterCodeOrigin = localStorage.getItem('codeOrigin');
    if (parameterCodeOrigin === expectedCode) {
      this.addClassToContainer(containerClass, containerButton);
    }
  }

  private addClassToContainer(containerClass: string, containerButton: string) {
    const containerTitle = document.querySelector(
      '.cardModalTitle',
    ) as HTMLElement;
    const containerButtonSelect = document.querySelector(
      '.vmBValider',
    ) as HTMLElement;
    if (containerTitle) {
      containerTitle.classList.add(containerClass);
      containerButtonSelect.classList.add(containerButton);
    }
  }

  private applyUpdateImageAndButton(
    expectedCode: string,
    imgMailSend: { imgMail?: string; imgClose?: string },
    classRef: string,
    classRetourOffre: string,
  ) {
    const parameterCodeOrigin = localStorage.getItem('codeOrigin');
    if (parameterCodeOrigin === expectedCode) {
      this.addClassToPopupBack(classRef, classRetourOffre);

      const imgSelect: any = {
        imgMail: `#devisCheckModal #avatar`,
        imgClose: `.closeModal2 img`,
      };

      for (const [key, src] of Object.entries(imgMailSend)) {
        if (src) {
          this.updateImageSource(`${imgSelect[key]}`, src);
        }
      }
    }
  }

  private updateImageSource(selector: string, src: string) {
    const imgElements = document.querySelectorAll<HTMLImageElement>(selector);
    imgElements.forEach((img) => {
      if (img.getAttribute('src') !== src) {
        img.src = src;
      }
    });
  }

  private addClassToPopupBack(
    paramClasseOffre: string,
    paramClasseRetourOffre: string,
  ) {
    const containerOffre = document.querySelector(
      '.dossierRef span',
    ) as HTMLElement;
    const containerRetourOffre = document.querySelector(
      '.modalContainer .modalButton',
    ) as HTMLElement;

    if (containerOffre) {
      containerOffre.classList.add(paramClasseOffre);
    }
    if (containerRetourOffre) {
      containerRetourOffre.classList.add(paramClasseRetourOffre);
    }
  }
}
export interface DialogData {
  numeroRang: number;
  email: string;
  tarif: QuotationModels.Tarif;
  currentFormulaWithGroup: PolicyModels.FormulaWithFormGroup;
  dataStoredQuotation: HealthModels.HealthQuotationStoredData;
}
